import { Injectable } from '@angular/core';

interface PendingOperationOptions {
  documentId?: string;
  callerName?: string;
}

const config = (<any>window).ftClientConfig;

@Injectable({
  providedIn: 'root'
})
export class PendingOperationService {
    
  private pendingOperations: { [key: string]: PendingOperationOptions } = {};
  private readonly documentSavePendingTimeoutMillis = config.documentSavePendingTimeoutMillis || 10000;

  addPendingOperation(operationName: string, options: PendingOperationOptions): void {
    const operationNameKey = `${operationName} ${options?.documentId ? options.documentId : ''} ${options?.callerName ? options.callerName : ''}`;

    if (this.pendingOperations[operationNameKey]) {
      throw new Error(`Pending operation '${operationNameKey}' already exists.`);
    }

    this.pendingOperations[operationNameKey] = options;
  }

  markOperationComplete(operationName: string, options: PendingOperationOptions): void {
    const operationNameKey = `${operationName} ${options?.documentId ? options.documentId : ''} ${options?.callerName ? options.callerName : ''}`;

    delete this.pendingOperations[operationNameKey];
  }

  waitForPendingOperations(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const logPendingOperations = () => {
        const pendingOperations = Object.keys(this.pendingOperations);
        console.log(`Waiting for pending operations before save: ${pendingOperations.join(', ')}`);
      };

      const cleanup = () => {
        clearTimeout(timeout);
        clearInterval(interval);
      };

      const checkPendingOperations = () => {
        logPendingOperations();
        if (Object.keys(this.pendingOperations).length === 0) {
          cleanup();
          resolve();
        }
      };

      if (Object.keys(this.pendingOperations).length === 0) {
        resolve();
        return;
      }

      const timeout = setTimeout(() => {
        cleanup();
        const unfinishedOperations = Object.keys(this.pendingOperations);
        reject(new Error(`Pending operations have not completed in the required time before save: ${unfinishedOperations.join(', ')}`));
      }, this.documentSavePendingTimeoutMillis);

      const interval = setInterval(checkPendingOperations, 1000);
      checkPendingOperations(); // Immediate check in case operations complete quickly
    });
  }
}
